import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { UserModel } from '../models/user.model';
import { environment } from '../environment/environment';
import { BackendResponse } from '@schenck/rotec-components';
import { filter, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class UserApi {
  private readonly http = inject(HttpClient);

  public create$(user: UserModel): Observable<UserModel> {
    return this.http
      .post<UserModel>(`${environment.apiBaseUrl}/user`, user)
      .pipe(filter((response) => !!response));
  }

  public update$(user: Partial<UserModel>): Observable<UserModel> {
    return this.http.put<UserModel>(`${environment.apiBaseUrl}/user/${user.id}`, user);
  }

  public get users$(): Observable<BackendResponse.Response<{ data: UserModel[] }>> {
    return this.http
      .get<{ data: UserModel[] }>(`${environment.apiBaseUrl}/user`)
      .pipe(BackendResponse.mapToResponse());
  }

  public delete$(id: string): Observable<void> {
    return this.http.delete<void>(`${environment.apiBaseUrl}/user/${id}`);
  }
}
